import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import HFDropdown from 'components/HFInputs/HFDropdown'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

import HFTextInput from 'components/HFInputs/HFTextInput'
import HFSwitchButton from 'components/HFInputs/HFSwitchButton'

import styles from './RuleEntryDetails.module.sass'
import { get, useFormContext } from 'react-hook-form'
import { useMemo } from 'react'

const textInputColors = [
	styles.textColorStrong,
	styles.textColorStrong,
	styles.backgroundColor,
	styles.backgroundColor,
	styles.textColor,
].join(';')

const ruleIcon = (
	<svg
		className={styles['icon']}
		width='12px'
		height='12px'
		viewBox='0 0 12 12'
	>
		<path d='M6 0C9.3135 0 12 2.6865 12 6C12 9.3135 9.3135 12 6 12C2.6865 12 0 9.3135 0 6C0 2.6865 2.6865 0 6 0ZM6 9.913C6.51913 9.9213 7.03471 9.82622 7.51673 9.6333C7.99875 9.44038 8.43757 9.15347 8.80761 8.78929C9.17766 8.42511 9.47154 7.99094 9.67214 7.51207C9.87275 7.0332 9.97606 6.51919 9.97606 6C9.97606 5.48081 9.87275 4.9668 9.67214 4.48793C9.47154 4.00906 9.17766 3.57489 8.80761 3.21071C8.43757 2.84653 7.99875 2.55962 7.51673 2.3667C7.03471 2.17378 6.51913 2.0787 6 2.087C4.97304 2.10342 3.9937 2.5229 3.27326 3.25494C2.55283 3.98699 2.14906 4.97291 2.14906 6C2.14906 7.02709 2.55283 8.01301 3.27326 8.74506C3.9937 9.4771 4.97304 9.89658 6 9.913ZM6 7.9205C5.49078 7.9205 5.00242 7.71821 4.64235 7.35815C4.28229 6.99808 4.08 6.50972 4.08 6.0005C4.08 5.49128 4.28229 5.00292 4.64235 4.64286C5.00242 4.28279 5.49078 4.0805 6 4.0805C6.50922 4.0805 6.99758 4.28279 7.35765 4.64286C7.71771 5.00292 7.92 5.49128 7.92 6.0005C7.92 6.50972 7.71771 6.99808 7.35765 7.35815C6.99758 7.71821 6.50922 7.9205 6 7.9205Z' />
	</svg>
)

const RuleEntryDetails = ({ onDelete, path, options, onChange }) => {
	const { i18n } = useGlobal()
	const { formState } = useFormContext()
	const errors = get(formState.errors ?? {}, path)
	const error = useMemo(() => {
		return (
			errors?.name?.message ??
			errors?.ruleAction?.message ??
			errors?.ruleEntity?.message
		)
	}, [errors])

	return (
		<span className={styles['rule-details']} data-error={error}>
			<VStack justify='space-around'>
				<HStack className={styles['title']} align='center'>
					{ruleIcon}
					<HFTextInput
						className={styles['text-input']}
						name={`${path}.name`}
						tint={textInputColors}
					/>
				</HStack>
				{options.ruleActions?.length > 0 ? (
					<HStack className={styles['title']} align='center'>
						<small>{i18n`On`}</small>
						<HFDropdown
							className={styles['full-size-selector']}
							options={options.ruleActions}
							name={`${path}.action`}
							onChange={onChange}
						/>
						<HFDropdown
							className={styles['full-size-selector']}
							options={options.ruleEntities}
							name={`${path}.actionEntity`}
							onChange={onChange}
						/>
					</HStack>
				) : null}
				<HStack justify='space-between'>
					<ActionButton
						type='button'
						className={styles['delete-button']}
						danger
						onClick={onDelete}
					>{i18n`Delete`}</ActionButton>
					<HStack justify='space-between' align='center' gap='xsmall'>
						{options.order?.length > 0 ? (
							<HFDropdown
								className={styles['selector']}
								tint={`${styles.backgroundColor};${styles.backgroundColor};${styles.textColor}`}
								name={`${path}.order`}
								options={options.order}
							/>
						) : null}
						<HFSwitchButton name={`${path}.enabled`} />
					</HStack>
				</HStack>
			</VStack>
		</span>
	)
}

export default RuleEntryDetails
